// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"499":"1336c12f","556":"1336c12f","707":"1336c12f"}[chunkId] + ".chunk.css";
};